/* @refresh reload */
// ladd-screenshot-client entry point (Solid refacto).
// Decision user `viewer_spa_strategy=refacto_solid` — SolidJS replaces vanilla modules.

import { render } from 'solid-js/web';
import { App } from './components/App';
import './styles/main.css';

const root = document.getElementById('app');
if (!root) throw new Error('[ladd-screenshot-client] #app root missing');

render(() => <App />, root);
